// extracted by mini-css-extract-plugin
export default {"body":"EditTagsModal_body__nLenS","saveButton":"EditTagsModal_saveButton__wF-Gu"};